import { getPaginationRange } from "@/lib/getPaginationRange";
import styles from "./pagination.module.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

type Props = {
  total: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export function Pagination({
  total,
  pageSize,
  currentPage,
  onPageChange,
}: Props) {
  const pages = getPaginationRange(total, pageSize, currentPage);

  return (
    <div className={styles.paginationWrapper}>
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={styles.backButton}
      >
        <MdKeyboardArrowLeft />
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={index}
            className={`${styles.button} ${
              page === currentPage && styles.active
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ) : (
          <span key={index} className={styles.dots}>
            ...
          </span>
        )
      )}

      <button
        disabled={currentPage === Math.ceil(total / pageSize)}
        onClick={() => onPageChange(currentPage + 1)}
        className={styles.nextButton}
      >
        <MdKeyboardArrowRight />
      </button>
    </div>
  );
}
